import { getInputValueForDate } from "./FilterChip.utils";

import { FilterDefinitionType } from "@/components/@types";

export const FILTER_OPERATORS_FOR_STRINGS = [
  // [
  //   {
  //     key: "exact",
  //     name: "Is Exactly",
  //     symbol: null,
  //     description: (el) => (
  //       <>
  //         Matches the exact <>{el}</>
  //       </>
  //     ),
  //   },
  // ],
  {
    key: "isNull",
    name: "Is Null",
    symbol: null,
    onlyOperator: true,
  },
  {
    key: "isNotNull",
    name: "Is Not Null",
    symbol: null,
    onlyOperator: true,
    getInputValue(_key, _value) {
      return { isNull: false };
    },
  },

  {
    key: "iExact",
    name: "Is Exactly",
    symbol: null,
  },

  {
    key: "iContains",
    name: "Contains",
    symbol: null,
  },
] as FilterDefinitionType["operators"];
export const FILTER_OPERATORS_FOR_NUMBERS = [
  {
    key: "gt",
    name: "is greater than",
    symbol: ">",
  },
  {
    key: "gte",
    name: "is greater than or equal",
    symbol: ">=",
  },
  {
    key: "lt",
    name: "is less than",
    symbol: "<",
  },
  {
    key: "lte",
    name: "less than or equal",
    symbol: "<=",
  },
  {
    key: "eq",
    name: "equal",
    symbol: "=",
  },
  {
    key: "ne",
    name: "not equal",
    symbol: "!=",
  },
] as FilterDefinitionType["operators"];
export const FILTER_OPERATORS_FOR_REFERENCES = [
  {
    key: "isNull",
    name: "Is Null",
    symbol: null,
    onlyOperator: true,
    getInputValue(key, value) {
      return { [key]: value };
    },
  },
  {
    key: "isNotNull",
    name: "Is Not Null",
    symbol: null,
    onlyOperator: true,
    getInputValue(_key, _value) {
      return { isNull: false };
    },
  },
  {
    key: "eq",
    name: "Is",
    symbol: "=",
    getInputValue(key, value) {
      return {
        [key]: value,
      };
    },
  },
  {
    key: "ne",
    name: "Is Not",
    symbol: "!=",
    getInputValue(key, value) {
      return {
        [key]: value,
      };
    },
  },
  {
    key: "inList",
    name: "Is Any Of",
    symbol: "[?]",
    getInputValue(key, value) {
      return {
        [key]: value,
      };
    },
  },
  {
    key: "notInList",
    name: "Is None Of",
    symbol: "![?]",
    getInputValue(key, value) {
      return {
        [key]: value,
      };
    },
  },
] as FilterDefinitionType["operators"];
export const FILTER_OPERATORS_FOR_DATES = [
  {
    key: "range",
    name: "In Range",
    symbol: "><",
    getInputValue(
      key,
      value: {
        date1: string;
        date2: string;
      },
    ) {
      return { gte: value?.date1, lte: value?.date2 };
    },
  },
  {
    key: "gt",
    name: "Is After",
    symbol: ">",
    getInputValue: getInputValueForDate,
  },
  {
    key: "gte",
    name: "Is After or On",
    symbol: ">=",
    getInputValue: getInputValueForDate,
  },
  {
    key: "lt",
    name: "Is Before",
    symbol: "<",
    getInputValue: getInputValueForDate,
  },
  {
    key: "lte",
    name: "Is Before or On",
    symbol: "<=",
    getInputValue: getInputValueForDate,
  },

  {
    key: "eq",
    name: "Is On",
    symbol: "=",
    getInputValue: getInputValueForDate,
  },
] as FilterDefinitionType["operators"];
export const FILTER_OPERATORS_FOR_ENUMS = [
  {
    key: "inList",
    name: "Is Any Of",
    symbol: "[?]",
  },
  {
    key: "notInList",
    name: "Is None Of",
    symbol: "![?]",
  },
  {
    key: "exact",
    name: "Is",
    symbol: "=",
  },
  {
    key: "ne",
    name: "Is Not",
    symbol: "!=",
  },
  {
    key: "isNull",
    name: "Is Null",
    symbol: null,
    onlyOperator: true,
  },
  {
    key: "isNotNull",
    name: "Is Not Null",
    symbol: null,
    onlyOperator: true,
    getInputValue(_key, _value) {
      return { isNull: false };
    },
  },
] as FilterDefinitionType["operators"];
export const FILTER_OPERATORS_FOR_BOOLEANS = [
  {
    key: "exact",
    name: "Exact",
    symbol: null,
    onlyOperator: true,
  },
] as FilterDefinitionType["operators"];
